var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPencil(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "lapiz",
    transform: "translate(-2 -2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_7659",
    "data-name": "Trazado 7659",
    d: "M12,21.244A1.244,1.244,0,0,1,13.244,20H23.2a1.244,1.244,0,0,1,0,2.488H13.244A1.244,1.244,0,0,1,12,21.244Z",
    transform: "translate(-2.442 -0.488)",
    fill: "#a6192e",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_7660",
    "data-name": "Trazado 7660",
    d: "M20.773,8.1a3.563,3.563,0,0,0,.339-5.038A3.309,3.309,0,0,0,18.748,2,4.278,4.278,0,0,0,15.91,3.1q-.035.029-.067.061L2.874,16.182A3,3,0,0,0,2,18.3v1.694A2.007,2.007,0,0,0,4,22H5.683a3,3,0,0,0,2.126-.883ZM17.207,5.793a1,1,0,0,0-1.414,1.414l1,1a1,1,0,1,0,1.414-1.414Z",
    transform: "translate(0)",
    fill: "#a6192e",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencil);
export default __webpack_public_path__ + "static/media/pencil.a85c7f6abd6607dfabb5011e831d4574.svg";
export { ForwardRef as ReactComponent };